import { FC, ReactNode } from 'react'
import { StyleSheet, View } from 'react-native'
import { Surface } from 'react-native-paper'
import { ColorsEnum } from '../../constants/colors'
import { isWeb } from '../../constants/platform'

interface AppBarProps {
    children: ReactNode
}

const AppBar: FC<AppBarProps> = ({ children }) => {
    return (
        <Surface elevation={4} style={styles.outerContainer}>
            <View style={styles.innerContainer}>{children}</View>
        </Surface>
    )
}

const styles = StyleSheet.create({
    outerContainer: {
        backgroundColor: ColorsEnum.PRIMARY,
        paddingTop: isWeb ? 0 : 20,
        zIndex: 1,
    },
    innerContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: 64,
    },
})

export default AppBar
